import { css } from "@emotion/react";
import { Table, TableBody, TableRow, Cell, TableHeader, TableHead } from "@vds/tables";
import { SmallText } from "../../components/core/utility";
import { CustomSmallText } from "./ContractDetailsData";
import { formatDate } from "../../../components/core/Utility";

const CustomTableHeader = css`
  margin-bottom: 0px;
  table-layout: fixed;
  thead {
    border-bottom: none;
    margin-bottom: 0;
    th {
      padding: 0.35rem 0rem 0.35rem 0rem;
      font-size: 0.7rem;
    }
  }
  tr {
    td {
      padding: 1px 1px 1px 0px;
      font-size: 0.7rem;
      line-height: 1;
    }

    border-bottom: none !important;
    border-top: none !important;
  }

  tr.first-subscription:not(:first-child) {
    border-top: 1px solid #e5e5e5 !important;
  }

  tr.vehicle-subscription:not(.first-subscription) {
    td {
      padding-top: 0px;
      padding-bottom: 0px;
    }
  }

  tr.first-subscription td {
    padding-top: 2px;
    padding-bottom: 0px;
  }

  td .smallText {
    line-height: 0.9;
    margin: 0;
    padding: 0;
  }

  tr.vehicle-row-even {
    background-color: rgb(240, 240, 240);
  }

  tr.vehicle-row-odd {
    background-color: #ffffff;
  }
`;

export const VehiclesHistoryTable = ({ data }) => {
  const renderTableRows = () => {
    if (!data?.length) {
      return <TableRow role="row">No Data to display</TableRow>;
    }

    const rows = [];

    // Sort by dateChanged descending (newest first), handle missing/invalid dates
    const sortedData = data.slice().sort((a, b) => {
      const ad = a?.dateChanged ? new Date(a.dateChanged).getTime() : -Infinity;
      const bd = b?.dateChanged ? new Date(b.dateChanged).getTime() : -Infinity;
      return bd - ad;
    });

    sortedData.forEach((vehicle, vehicleIndex) => {
      const rowColorClass = vehicleIndex % 2 === 0 ? "vehicle-row-even" : "vehicle-row-odd";

      const isFirst = vehicleIndex === 0;

      const rowClassName = `vehicle-subscription ${isFirst ? "first-subscription" : ""} ${rowColorClass}`;

      rows.push(
        <TableRow key={vehicleIndex} role="row" className={rowClassName}>
          <Cell role="cell" width="25%">
            <SmallText aria-label={vehicle.oldYmm}>{vehicle.oldYmm ? vehicle.oldYmm : "--"}</SmallText>
            <SmallText aria-label={vehicle.oldVin}>
              {vehicle.oldVin.startsWith("VIN_") ? <strong>--</strong> : <strong>{vehicle.oldVin}</strong>}
            </SmallText>
          </Cell>
          <Cell role="cell" width="25%">
            <SmallText aria-label={vehicle.newYmm}>{vehicle.newYmm ? vehicle.newYmm : "--"}</SmallText>
            <SmallText aria-label={vehicle.newVin}>
              {vehicle.newVin.startsWith("VIN_") ? <strong>--</strong> : <strong>{vehicle.newVin}</strong>}
            </SmallText>
          </Cell>
          <Cell role="cell" width="25%">
            <SmallText aria-label={vehicle.dateChanged}>
              {vehicle.dateChanged ? formatDate(vehicle.dateChanged, "MMM DD, yyyy, hh:mm:ss") : "--"}
            </SmallText>
          </Cell>
          <Cell role="cell" width="25%">
            <SmallText aria-label={vehicle.changedBy}>{vehicle.changedBy ? vehicle.changedBy : "--"}</SmallText>
          </Cell>
        </TableRow>
      );
    });

    return rows;
  };

  return (
    <>
      <Table role="table" tabIndex={0} topLine="none" css={CustomTableHeader}>
        <TableHead role="row" tabIndex={0}>
          <TableHeader tabIndex={0} role="columnheader" id="Vehicles/Assets" width="25%">
            <CustomSmallText tabIndex={0} bold>
              Old Vehicle
            </CustomSmallText>
          </TableHeader>
          <TableHeader role="columnheader" id="traits" width="25%">
            <CustomSmallText bold>New Vehicle</CustomSmallText>
          </TableHeader>
          <TableHeader role="columnheader" id="subscriptionId" width="25%">
            <CustomSmallText bold>Date Changed</CustomSmallText>
          </TableHeader>
          <TableHeader role="columnheader" id="techRefId" width="25%">
            <CustomSmallText bold>Changed By</CustomSmallText>
          </TableHeader>
        </TableHead>
        <TableBody role="rowgroup" tabIndex={0}>
          {renderTableRows()}
        </TableBody>
      </Table>
    </>
  );
};
